import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
var Link = /*#__PURE__*/_createClass(function Link(options) {
  _classCallCheck(this, Link);
  this.type = options.type || 'link';
  this.children = options.children || [{
    text: ''
  }];
  this.data = options.data || {
    href: ''
  };
});
var generateLinkElement = function generateLinkElement(options) {
  return Object.assign({}, new Link(options));
};
export default generateLinkElement;